(function (root, app) {
    // From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
    if (!Object.keys) {
        Object.keys = (function () {
            'use strict';
            var hasOwnProperty = Object.prototype.hasOwnProperty,
                hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
                dontEnums = [
                  'toString',
                  'toLocaleString',
                  'valueOf',
                  'hasOwnProperty',
                  'isPrototypeOf',
                  'propertyIsEnumerable',
                  'constructor'
                ],
                dontEnumsLength = dontEnums.length;

            return function (obj) {
                if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
                    throw new TypeError('Object.keys called on non-object');
                }

                var result = [], prop, i;

                for (prop in obj) {
                    if (hasOwnProperty.call(obj, prop)) {
                        result.push(prop);
                    }
                }

                if (hasDontEnumBug) {
                    for (i = 0; i < dontEnumsLength; i++) {
                        if (hasOwnProperty.call(obj, dontEnums[i])) {
                            result.push(dontEnums[i]);
                        }
                    }
                }
                return result;
            };
        }());
    }

    if (!Object.size) {
        Object.size = function(obj) {
            var size = 0, key;
            for (key in obj) {
                if (obj.hasOwnProperty(key)) size++;
            }
            return size;
        };
    }

    if (!Date.prototype.getWeekNumber) {
        Date.prototype.getWeekNumber = function () {
            // Copy date so don't modify original
            var d = new Date(+this);
            d.setHours(0, 0, 0);
            // Set to nearest Thursday: current date + 4 - current day number
            // Make Sunday's day number 7
            d.setDate(d.getDate() + 4 - (d.getDay() || 7));
            // Calculate full weeks to nearest Thursday
            return Math.ceil((((d - new Date(d.getFullYear(), 0, 1)) / 8.64e7) + 1) / 7);
        };
    }

    if (!Date.dateDiff) {
        // datepart: 'y', 'm', 'w', 'd', 'h', 'n', 's'
        Date.dateDiff = function (datepart, fromdate, todate) {
            datepart = datepart.toLowerCase();
            var diff = todate - fromdate;
            var divideBy = {
                w: 604800000,
                d: 86400000,
                h: 3600000,
                n: 60000,
                s: 1000
            };

            return Math.floor(diff / divideBy[datepart]);
        }
    }

    if (!Date.cparse) {
        Date.cparse = function (dateString) {
            var time = new Date(dateString);
            if (time == "Invalid Date") return time;

            var test = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/g;
            // TODO: if database dates are UTC, uncomment this line to convert it to local time.
            //if (typeof dateString == "string" && test.test(dateString)) time.setMinutes(time.getMinutes() + time.getTimezoneOffset());
            return time;
        }
    }

    if (!Array.prototype.equals) {
        // attach the .equals method to Array's prototype to call it on any array
        Array.prototype.equals = function (array) {
            // if the other array is a falsy value, return
            if (!array)
                return false;

            // compare lengths - can save a lot of time 
            if (this.length != array.length)
                return false;

            for (var i = 0, l = this.length; i < l; i++) {
                // Check if we have nested arrays
                if (this[i] instanceof Array && array[i] instanceof Array) {
                    // recurse into the nested arrays
                    if (!this[i].equals(array[i]))
                        return false;
                }
                else if (this[i] != array[i]) {
                    // Warning - two different object instances will never be equal: {x:20} != {x:20}
                    return false;
                }
            }
            return true;
        }
    }

    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, argument) {
            argument = argument || window;
            for (var i = 0; i < this.length; i++) {
                callback.call(argument, this[i], i, this);
            }
        };
    }

    // allows you to delay execution by 1 call
    root.inception = function(func, context) {
        var locked = true;
        return function () {
            if (locked) locked = false;
            else if (arguments.length === 0) {
                return func.call(context || this);
            } else {
                return func.apply(context || this, arguments);
            }
            return null;
        }
    }

    root.extractResponseMessage = function(response) {
	    if (!response) {
	        return undefined;
	    }

	    if (typeof response == "string") {
	        return response;
	    }

	    if (typeof response == "object") {
	        var ends = ["responseJSON", "responseText", "Message", "message"];
	        for (var i = 0, len = ends.length; i < len; i++) {
	            var end = ends[i];
	            if (response[end] != undefined) {
	                return extractResponseMessage(response[end]);
	            }
	        }
	    }

	    return undefined;
    }

    root.parseQueryString = function(value, parameterDelimiter, nameValueDelimiter) {
        var result = {};
        if (!!value) {
            parameterDelimiter = parameterDelimiter || "&";
            nameValueDelimiter = nameValueDelimiter || "=";
            _.each(value.split(parameterDelimiter), function(obj) {
                var parts = obj.split(nameValueDelimiter);
                result[parts[0]] = parts[1];
            });
        }
        return result;
    }

    root.stringToBool = function (value) {
        if (!value) return false;
        switch(value.toLowerCase()) {
            case "true":
            case "1":
            case "yes":
            case "y":
                return true;
            case "n":
            case "no":
            case "0":
            case "false":
            default:
                return false;
        }
    }

    root.toArray = function(collection){
        return collection instanceof Array ? collection : collection.toArray ? collection.toArray() : _.toArray(collection);
    };

    var appReady = function(isReady) {
        if (arguments.length === 0) {
            return !!appReady.isReady;
        }

        if (!!appReady.isReady === !!isReady) return !!isReady;
        appReady.isReady = !!isReady;
        if (!!isReady) {
            appReady.loadTime = performance.now();
            appReady.url = location.toString();
            if (app && app.trigger) app.trigger("ready");
            if (window.events) events.trigger("app:ready");
        } else {
            appReady.loadTime = null;
            delete appReady.loadTime;
            appReady.url = null;
            delete appReady.url;
        }
        
        return appReady.isReady;
    };

    appReady.toString = function() {
        return appReady.url + appReady.loadTime;
    }

    root.appReady = appReady;

    root.setupModals = function (el) {
        el.find(".fp-modal").each(function () {
            var modal = $(this).modalForm(/*header*/);
            modal.onshow = function () {
                var first = $(this).find("input:text, textarea, select").first();
                first.focus();
                if (first.is("select")) {
                    first.trigger("chosen:activate");
                }
            }
            this.modal = modal;

            var button = $("[data-fp-modal=" + $(this).attr("id") + "]");
            if (button) {
                button.click(function () {
                    modal.toggle();
                });
            }
        });
    }

    root.setupModal = function (el) {
        var modal = $(el).modalForm(/*header*/);
        modal.onshow = function () {
            var first = $(this).find("input:text, textarea, select").first();
            first.focus();
            if (first.is("select")) {
                first.trigger("chosen:activate");
            }
        }
        $(el)[0].modal = modal;
        return modal;
    }

    /*Function used for toggling input labels when new users, maps, cameras, etc. are added or edited.*/
	root.setupDynamicLabels = function (el, trigger) {
	    var $el = el instanceof $ ? el : $(el);
	    trigger = trigger != undefined ? trigger : true;

	    //var inputs = $el.find(".field input[type=text]");
        $el.on("change", ".field input[type=text]", function (e) {
            var label = $(e.target).siblings("label.field-label")[0];
            if (label) {
                toggleInputLabels(label, e.target);
            }
        });

        if (trigger) {
            $el.find(".field input[type=text]").trigger("change");
        }
	}

    root.hexToRgb = function(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    root.rgbToHex = function(r, g, b) {
        return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
    }

    function componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }

	function toggleInputLabels(label, target) {
	    var $input = $(target);
	    var $label = $(label);
	    var val = $input.val();

	    if (val.length > 0) {
	        var paddingLeft;
	        if (!target.hasAttribute('default-left-padding')) {
	            paddingLeft = $input.css("padding-left");
	            $input.attr('default-left-padding', paddingLeft);
	        } else {
	            paddingLeft = $input.attr('default-left-padding');
	        }

	        var labelLength = $label.width();
	        var padding = parseInt(paddingLeft) + parseInt(labelLength) + 1;
	            
	        $input.animate({ 'padding-left': padding + "px" });
	        $label.fadeIn();
	    }
	    else if (val.length == 0) {
	        var defaultPadding = $input.attr('default-left-padding');
	        $label.fadeOut();
	        $input.animate({ 'padding-left': defaultPadding });
	    }
	}

	function setCookie(cname, cvalue, exdays) {
	    var d = new Date();
	    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	    var expires = "expires=" + d.toUTCString();
	    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function getCookie(cname) {
	    var name = cname + "=";
	    var ca = document.cookie.split(';');
	    for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	            return c.substring(name.length, c.length);
	        }
	    }
	    return "";
	}

	root.setCookie = setCookie;
	root.getCookie = getCookie;

    // JQuery Extensions
    $.fn.serializeObject = function() {
        return $(this).serializeArray().reduce(function(obj, item) {
            obj[item.name] = item.value;
            return obj;
        }, {});
    };

    if ($.fn.select2) $.fn.select2.textValueMatcher = function (query, option) {
        if (query.term && option.id.toUpperCase().indexOf(query.term.toUpperCase()) !== -1) return option;
        var result = $.fn.select2.defaults.defaults.matcher.apply(this, arguments);
        return result;
    }
})(window, window.app)
